<template>
    <div>
        <v-app-bar
            app
            color="rgb(228 228 228)"
            light
            shrink-on-scroll2
            flat
        >
            <v-app-bar-nav-icon @click="drawer = true" class="hidden-md-and-up"></v-app-bar-nav-icon>
            <v-container class="pr-6 pl-6">
                <div id="ww-utils">
                    <v-btn small icon class="ml-2 mt-0 pt-0" v-for="social in socials" :key="social.icon"
                           :href="social.path" target="_blank">
                        <v-icon>{{ social.icon }}</v-icon>
                    </v-btn>
                    <locale-changer style="float:right;" class="ml-6"></locale-changer>
                </div>
                <v-toolbar-title id="ww-title">
                    <router-link :to="'/' + $i18n.locale"><span>Wiebke Winzer</span>
                    <logo></logo>
                        <span>{{ $t('logo.claim') }}</span></router-link>
                </v-toolbar-title>
            </v-container>

            <template v-slot:extension>
                <v-tabs
                    centered
                    class="hidden-sm-and-down"
                >
                    <v-tab v-for="route in routes"
                           exact-active-class="exact-active2"
                           :key="route.path" 
                           :to="'/' + $i18n.locale + '/' + route.path"
                           class="font-weight-light ww-tab">
                        {{ $t('menu.' + route.name) }}
                    </v-tab>
                </v-tabs>
            </template>
        </v-app-bar>

        <v-navigation-drawer app
                             v-model="drawer"
                             temporary
                             
        >
            <span id="drawer-logo" class="title ml-6 mt-12">Wiebke Winzer<logo style="vertical-align: middle"></logo>THERAPIE</span>

            <v-divider></v-divider>

            <v-list
                dense
                nav
            >
                <v-list-item
                    :exact-active-class="'exact-active'"
                    v-for="route in routes"
                    :key="route.path"
                    link
                    :to="'/' + $i18n.locale + '/' + route.path"
                >
                    <v-list-item-icon>
                        <v-icon>{{ route.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title class="font-weight-light">{{ $t('menu.' + route.name) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import router from '@/router.js';
import Logo from "@/assets/logo.vue";
import LocaleChanger from "@/components/core/LocaleSelect.vue";
import Custom from "@/plugins/Custom";

export default {
    name: 'CoreNav',
    components: {
        LocaleChanger,
        Logo
    },
    data() {
        return {
            drawer: false,
            routes: Custom.getRouteConfigs().filter(route => route.section === 'main-nav'),
            socials: router.options.socials,
        }
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
#ww-utils {
    float: right;
    line-height: 1em;
}

#ww-title {
    font-family: var(--logo-font-family) !important;
    color: var(--logo-font-color);
    text-shadow: 0 0 rgba(0, 0, 0, 0.2);
    vertical-align: text-top;
    display: inline-block;
}
#ww-title span {
    color: var(--logo-font-color);
}

#drawer-logo {
    font-family: var(--logo-font-family) !important;
    color: var(--logo-font-color);
    text-shadow: 0 0 rgba(0, 0, 0, 0.2);
    vertical-align: text-top;
}

.v-toolbar {
    box-shadow: -4px 2px 1px -1px rgba(0, 0, 0, 0.1), 0px 4px 117px -1px rgba(0, 0, 0, 0.1), 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
}

.v-btn {
    color: var(--v-primary-base) !important;
}

.ww-tab {
    font-size: 0.8rem !important;
}

.v-tab--active {
    color: var(--v-accent-base) !important;
}

header {
    background-color: var(--v-secondary-base) !important;
}

.v-application .title {
    line-height: 3rem;
}

.exact-active {
    color:var(--v-primary-base) !important;
}
.exact-active::before {
    opacity: 0.12 !important;
}
.exact-active2 {
    color:var(--v-primary-base) !important;
    opacity: 1 !important;
}
.exact-active2::before {
    opacity: 0.12 !important;
}

.v-tab--active {
    color: black;
    opacity: 0.54;
}

.v-list-item--active {
    background-color:transparent; //reset to non-active due to parent highlighting
}
.v-list-item--active::before {
    opacity: 0; //reset to non-active due to parent highlighting
}
</style>
